import { mPerLat, mPerLon } from './geo';

// track geometry for the 3D flyover: cumulative metres, interpolated position, smoothed heading
export function flyPath(pts) {
  const p = (pts || []).filter((x) => x.lat != null && x.lon != null);
  const d = [0];
  for (let i = 1; i < p.length; i++) d.push(d[i - 1] + Math.hypot((p[i].lat - p[i - 1].lat) * mPerLat(p[i].lat), (p[i].lon - p[i - 1].lon) * mPerLon(p[i].lat)));
  return { p, d, len: d[d.length - 1] || 0 };
}

export function at(path, m) {
  const { p, d } = path;
  if (!p.length) return null;
  let i = d.findIndex((x) => x >= m);
  if (i <= 0) return { ...p[i < 0 ? p.length - 1 : 0], i: Math.max(0, i < 0 ? p.length - 1 : 0) };
  const f = (m - d[i - 1]) / ((d[i] - d[i - 1]) || 1), a = p[i - 1], b = p[i];
  return { lat: a.lat + (b.lat - a.lat) * f, lon: a.lon + (b.lon - a.lon) * f, alt: a.alt != null && b.alt != null ? a.alt + (b.alt - a.alt) * f : a.alt ?? b.alt, i };
}

const brg = (a, b) => (Math.atan2((b.lon - a.lon) * mPerLon(a.lat), (b.lat - a.lat) * mPerLat(a.lat)) * 180) / Math.PI;
// look ~250 m ahead so the camera turns smoothly
export const headAt = (path, m) => { const a = at(path, m), b = at(path, Math.min(path.len, m + Math.max(60, path.len * 0.04))); return a && b ? brg(a, b) : 0; };
export const lerpAngle = (a, b, f) => a + ((((b - a) % 360) + 540) % 360 - 180) * f;

// photos -> distance along the route (by position, else by time), max 12, preloaded
export function flyPhotos(path, list) {
  const { p, d } = path;
  const near = (x) => {
    let bi = 0, bv = Infinity;
    p.forEach((q, i) => { const v = x.lat != null ? (q.lat - x.lat) ** 2 + ((q.lon - x.lon) * Math.cos((q.lat * Math.PI) / 180)) ** 2 : Math.abs((q.t || 0) - (x.t || 0)); if (v < bv) { bv = v; bi = i; } });
    return d[bi] || 0;
  };
  const step = Math.max(1, Math.ceil(list.length / 12));
  return list.filter((_, i) => i % step === 0).map((x) => { const img = new Image(); img.src = x.data; return { img, cap: x.cap, m: near(x) }; }).sort((a, b) => a.m - b.m);
}
